module.exports = __webpack_public_path__ + "static/media/FiraSans-ExtraLight.882c94da.ttf";